import { render, staticRenderFns } from "./card-info-dialog.vue?vue&type=template&id=2ad73512&scoped=true&"
import script from "./card-info-dialog.vue?vue&type=script&lang=js&"
export * from "./card-info-dialog.vue?vue&type=script&lang=js&"
import style0 from "./card-info-dialog.vue?vue&type=style&index=0&id=2ad73512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad73512",
  null
  
)

export default component.exports